<script lang="ts">
	import { page } from '$app/state';
	import Advertising from '$lib/components/advertising/Advertising.svelte';
	import { getPageName } from '$lib/services/urls/routeIds';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';

	const searchParams = getSearchParamsStore();

	interface Props {
		mapWidth: number;
	}

	const { mapWidth }: Props = $props();

	const WIDTH_THRESHOLD = 1002;
	const MAX_AD_FORMAT = 1000;
	const MIN_AD_FORMAT = 728;
	const pageName = getPageName(page);
	const isRouteResultsPage = pageName === 'routeresults';
	const shouldDisplayLargeBanner = isRouteResultsPage && page.data.locale === 'fr-FR'; // TODO: for now only on FR, to be removed when AdFormat will be refactored

	const adWidth = shouldDisplayLargeBanner ? mapWidth >= WIDTH_THRESHOLD ? MAX_AD_FORMAT : MIN_AD_FORMAT : MIN_AD_FORMAT;
	const adId = shouldDisplayLargeBanner ? adWidth === MAX_AD_FORMAT ? 'map-banner-1000' : 'map-banner' : 'map-banner';
</script>

{#if mapWidth >= adWidth}
	{#key `${page.route.id}-${$searchParams.selectedAddress?.address}-${$searchParams.poiCategories}`}
		<Advertising {adId} adFormat={{ desktop: `${adWidth}x90` }} />
	{/key}
{/if}
